import { render, staticRenderFns } from "./listDataVisits.vue?vue&type=template&id=cbca12ca"
import script from "./listDataVisits.vue?vue&type=script&lang=js"
export * from "./listDataVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports